import React, { useState } from 'react';

import { List, Radio } from 'antd';

import ConversionModal from '@components/ConversionModal';
import { NwButton } from '@components/Gui/NwButton';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const ConversionSelector = ({ value, onChange, conversions }) => {
    const [conversion, setConversion] = useState();
    const handleSetConversion = (conversion) => () => {
        onChange(conversion.ID);
    };

    const handleCloseModal = () => {
        setConversion();
    };

    return (
        <>
            <List
                bordered
                size="small"
                dataSource={conversions}
                renderItem={(conversion) => (
                    <List.Item
                        actions={[
                            <NwButton
                                size="small"
                                iconOnly
                                icon={byPrefixAndName.fasl['eye']}
                                onClick={() => setConversion(conversion)}
                            />,
                        ]}
                    >
                        <Radio checked={value === conversion.ID} onClick={handleSetConversion(conversion)}>
                            {conversion.Name}
                        </Radio>
                    </List.Item>
                )}
            />
            {conversion && <ConversionModal conversion={conversion} onClose={handleCloseModal} />}
        </>
    );
};

export default ConversionSelector;
